import { ProductSubTier, SubscriptionPlanName } from '@sparemin/api-sdk';
import { MultiVideoCameraGrowGradientIcon } from '@sparemin/blockhead';
import cn from 'classnames';
import React, { useCallback } from 'react';
import { PlanInstanceProps } from 'blocks/Pricing/types';

import { PREV_GROW_PLAN_MONTHLY_COST } from 'constants/pricing';
import useCost from 'hooks/useCost';
import { proFeatureList } from '../features';
import Plan from '../Plan';
import ProGrowPlanCta from './ProGrowPlanCta';
import ProGrowPlanDescription from './ProGrowPlanDescription';
import { block } from './utils';

const ProGrowPlan: React.FC<PlanInstanceProps> = ({
  period,
  className,
  onUpgradeClick,
}) => {
  const previousCost = useCost(PREV_GROW_PLAN_MONTHLY_COST);

  const handleUpgradeClick = useCallback(() => {
    onUpgradeClick({
      subtier:
        period === 'monthly'
          ? ProductSubTier.PRO_GROW_20251120_MONTHLY
          : ProductSubTier.PRO_GROW_20251120_YEARLY,
    });
  }, [onUpgradeClick, period]);

  return (
    <Plan className={cn(block(), className)}>
      <Plan.SubPeriodHeader
        theme="pro-grow"
        title="Pro + Grow"
        description="Completely automate and advertise your podcast across the web."
        icon={<MultiVideoCameraGrowGradientIcon />}
        period={period}
        isLimitedTime={period === 'monthly'}
        cost={{
          monthly: SubscriptionPlanName.PRO_GROW_20251120_MONTHLY,
          yearly: SubscriptionPlanName.PRO_GROW_20251120_YEARLY,
        }}
        previousCost={period === 'monthly' ? `${previousCost}/mo` : undefined}
        className={block('header')}
      />
      <Plan.Description
        callToAction={
          <ProGrowPlanCta onClick={handleUpgradeClick} period={period} />
        }
        features={proFeatureList}
      >
        <ProGrowPlanDescription />
      </Plan.Description>
    </Plan>
  );
};

export default ProGrowPlan;
